import VueGoogleMaps from "@fawmi/vue-google-maps";
import { Amplify } from "aws-amplify";
import { createApp } from "vue";
import VueApexCharts from "vue3-apexcharts";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import awsExports from '@/aws-exports'; // Adjust the path as needed

Amplify.configure(awsExports);

loadFonts();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.VUE_APP_AWS_USER_POOL_ID,
      userPoolClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: process.env.VUE_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
      region: process.env.VUE_APP_AWS_APPSYNC_REGION,
      defaultAuthMode: "userPool",
    },
    endpoints: [
      {
        name: "Report_issue",
        endpoint: process.env.VUE_APP_REST_API_BASE_URL,
      },
    ],
  },
});
createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(VueApexCharts)
  .use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAP_KEY_VOZCARE_PORTAL,
      libraries: "places",
    },
  })
  .mount("#app");
